(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
  function syncQty(card) {
    var qtyInput = card.querySelector('[data-qty-input]');
    var qtyHidden = card.querySelector('[data-qty-hidden]');
    if (!qtyInput) return;
    var val = Math.max(1, parseInt(String(qtyInput.value).replace(/\D/g, ''), 10) || 1);
    qtyInput.value = val;
    if (qtyHidden) qtyHidden.value = val;
  }

  function getCard(el) {
    return el && el.closest ? el.closest('[data-product-card]') : null;
  }

  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-qty-minus]');
    var plusBtn = e.target.closest('[data-qty-plus]');
    if (!minusBtn && !plusBtn) return;

    var card = getCard(minusBtn || plusBtn);
    if (!card || !card.closest('[data-section-type="section-product-v3"]')) return;

    e.preventDefault();
    e.stopPropagation();

    var qtyInput = card.querySelector('[data-qty-input]');
    if (!qtyInput) return;

    var val = parseInt(String(qtyInput.value).replace(/\D/g, ''), 10) || 1;
    if (plusBtn) {
      qtyInput.value = val + 1;
    } else {
      qtyInput.value = Math.max(1, val - 1);
    }
    syncQty(card);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-qty-input]')) return;
    var card = getCard(e.target);
    if (card) syncQty(card);
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-qty-input]')) return;
    var card = getCard(e.target);
    if (card) syncQty(card);
  });

  function initVariantSelects(root) {
    root.querySelectorAll('[data-variant-select]').forEach(function (variantSelect) {
      if (variantSelect.dataset.drvaidyaBound === 'true') return;
      variantSelect.dataset.drvaidyaBound = 'true';

      variantSelect.addEventListener('change', function () {
        var card = getCard(variantSelect);
        if (!card) return;
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var variantIdInput = card.querySelector('[data-variant-id]');
        var priceCurrent = card.querySelector('[data-price-current]');
        var priceCompare = card.querySelector('[data-price-compare]');

        if (variantIdInput) variantIdInput.value = opt.value;
        if (priceCurrent && opt.dataset.price) priceCurrent.textContent = opt.dataset.price;
        if (priceCompare) {
          if (opt.dataset.compare) {
            priceCompare.textContent = opt.dataset.compare;
            priceCompare.removeAttribute('hidden');
          } else {
            priceCompare.setAttribute('hidden', 'hidden');
          }
        }
      });
    });
  }

  function initSection(root) {
    initVariantSelects(root);
    root.querySelectorAll('[data-product-card]').forEach(syncQty);
  }

  function boot() {
    document.querySelectorAll('[data-section-type="section-product-v3"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section && section.getAttribute('data-section-type') === 'section-product-v3') {
      initSection(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
